<div class="container-fluid">

  <!-- Heading -->
  <div class="row pt-4 pl-4" style="font-size: 22px !important; font-weight: 400; color: #424242;">
    <h5><i class="fa fa-circle" style="color:#800000"></i> &nbsp;My Report</h5>
  </div>

  <div class="container">
    <div class="modal-body">

      <!-- SINGLE ROW: Cards will wrap automatically, 3 per row -->
      <div class="row g-4 gy-5">

        <div class="col-12 col-sm-6 col-lg-4" *ngIf="hasAccess('My Leave Details')">
          <div class="card shadow mb-4" style="align-items: center;">
            <div class="card-body">
              <div style="color:#800000; text-decoration:underline; cursor:pointer;font-size:16px;"
                   (click)="myLeavesDetailsClick()">My Leave Details</div>
            </div>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-lg-4" *ngIf="hasAccess('My Diaries')">
          <div class="card shadow mb-4" style="align-items: center;">
            <div class="card-body">
              <div style="color:#800000; text-decoration:underline; cursor:pointer;font-size:16px;"
                   (click)="myDiariesClick()">My Diaries</div>
            </div>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-lg-4" *ngIf="hasAccess('My Salary Closing') else elseBlock1">
          <div class="card shadow mb-4" style="align-items: center;">
            <div class="card-body">
              <div style="color:#800000; text-decoration:underline; cursor:pointer;font-size:16px;"
                   (click)="mySalaryClosingClick()">My Salary Closing</div>
            </div>
          </div>
        </div>

        <ng-template #elseBlock1>
          <div class="col-12 col-sm-6 col-lg-4" *ngIf="hasAccess('My Stipend')">
            <div class="card shadow mb-4" style="align-items: center;">
              <div class="card-body">
                <div style="color:#800000; text-decoration:underline; cursor:pointer;font-size:16px;"
                     (click)="myStipendClick()">My Stipend</div>
              </div>
            </div>
          </div>
        </ng-template>

        <div class="col-12 col-sm-6 col-lg-4" *ngIf="hasAccess('My Penalty Summary')">
          <div class="card shadow mb-4" style="align-items: center;">
            <div class="card-body">
              <div style="color:#800000; text-decoration:underline; cursor:pointer;font-size:16px;"
                   (click)="myPenaltySummaryClick()">My Penalty Summary</div>
            </div>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-lg-4" *ngIf="hasAccess('My Independence Declaration')">
          <div class="card shadow mb-4" style="align-items: center;">
            <div class="card-body">
              <div style="color:#800000; text-decoration:underline; cursor:pointer;font-size:16px;"
                   (click)="myAnnualDeclarationClick()">My Independence Declaration</div>
            </div>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-lg-4" *ngIf="hasAccess('My Actual Task Summary Report') else elseBlock2">
          <div class="card shadow mb-4" style="align-items: center;">
            <div class="card-body">
              <div style="color:#800000; text-decoration:underline; cursor:pointer;font-size:16px;"
                   (click)="myActualTaskClick()">My Actual Task Summary Report</div>
            </div>
          </div>
        </div>

        <ng-template #elseBlock2>
          <div class="col-12 col-sm-6 col-lg-4" *ngIf="hasAccess('Article Debit Credit Report')">
            <div class="card shadow mb-4" style="align-items: center;">
              <div class="card-body">
                <div style="color:#800000; text-decoration:underline; cursor:pointer;font-size:16px;"
                     (click)="myArticleDebitCreditClick()">Article Debit Credit Report</div>
              </div>
            </div>
          </div>
        </ng-template>

        <div class="col-12 col-sm-6 col-lg-4" *ngIf="hasAccess('My Article 1/6 Report')">
          <div class="card shadow mb-4" style="align-items: center;">
            <div class="card-body">
              <div style="color:#800000; text-decoration:underline; cursor:pointer;font-size:16px;"
                   (click)="myArticleOneSixthClick()">My Article 1/6 Report</div>
            </div>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-lg-4" *ngIf="hasAccess('My Targets')">
          <div class="card shadow mb-4" style="align-items: center;">
            <div class="card-body">
              <div style="color:#800000; text-decoration:underline; cursor:pointer;font-size:16px;"
                   (click)="myTargetClick()">My Targets</div>
            </div>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-lg-4" *ngIf="hasAccess('My Variance Report')">
          <div class="card shadow mb-4" style="align-items: center;">
            <div class="card-body">
              <div style="color:#800000; text-decoration:underline; cursor:pointer;font-size:16px;"
                   (click)="myVarianceReportClick()">My Variance Report</div>
            </div>
          </div>
        </div>

      </div>
      <!-- END SINGLE ROW -->

    </div>
  </div>
</div>